module.exports = __webpack_public_path__ + "static/media/TaskRotation.500a755.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/TaskRotation.mp4
// module id = Aqyo
// module chunks = 1